export default "__VITE_ASSET__BVP0Dm7A__"